import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=135eadc2&scoped=true"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"
import style0 from "./PageNotFound.vue?vue&type=style&index=0&id=135eadc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135eadc2",
  null
  
)

export default component.exports